import { render, staticRenderFns } from "./SvgPlus.vue?vue&type=template&id=5ab13a46&scoped=true&"
import script from "./SvgPlus.vue?vue&type=script&lang=js&"
export * from "./SvgPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab13a46",
  null
  
)

export default component.exports